import axios from 'axios';

import {
  axiosHeaderV2,
  getV2RootUrl,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const authenticateForFullSteamWallet = () =>
  axios.post(
    `${getV2RootUrl()}/payment/fullsteam/club-signup/auth-digital-wallet`,
    {},
    publicAxiosHeaderV2()
  );

export const getClubSignupForSharing = (clubSignupId, customerId) => {
  if (customerId) {
    return axios.get(
      `${getV2RootUrl()}/club-signup/${clubSignupId}/for-sharing`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/for-sharing`,
    publicAxiosHeaderV2()
  );
};

export const getClubSignup = (clubSignupId) =>
  axios.get(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/for-web`,
    publicAxiosHeaderV2()
  );

export const createClubSignup = (clubSignup) =>
  axios.post(
    `${getV2RootUrl()}/club-signup`,
    clubSignup,
    publicAxiosHeaderV2()
  );

export const updateClubSignup = (clubSignupId, clubSignup) =>
  axios.put(
    `${getV2RootUrl()}/club-signup/${clubSignupId}`,
    clubSignup,
    publicAxiosHeaderV2()
  );

export const editVirtualSignUp = (clubSignupId, payload) =>
  axios.put(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/virtual-cart`,
    payload,
    publicAxiosHeaderV2()
  );

export const getVirtualCart = (clubSignupId, queryParams) => {
  if (queryParams) {
    return axios.get(
      `${getV2RootUrl()}/club-signup/${clubSignupId}/virtual-cart?${queryParams}`,
      publicAxiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/virtual-cart`,
    publicAxiosHeaderV2()
  );
};

export const processClubSignup = (clubSignupId, payload) =>
  axios.put(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/process`,
    payload,
    publicAxiosHeaderV2()
  );

export const processFullsteamClubSignup = (clubSignupId, payload) =>
  axios.post(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/fullsteam/process-payment-for-digital-wallet`,
    payload,
    publicAxiosHeaderV2()
  );

export const createCustomerAndSetupIntent = (clubSignupId, customerPayload) =>
  axios.post(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/customer-and-setup-intent`,
    customerPayload,
    publicAxiosHeaderV2()
  );

export const processClubSignupFromPaymentRequest = (
  clubSignupId,
  clubSignupUpdateParams
) =>
  axios.put(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/process-from-payment-request`,
    clubSignupUpdateParams,
    publicAxiosHeaderV2()
  );

export const processPayStackClubSignup = (clubSignupId, payload) =>
  axios.put(
    `${getV2RootUrl()}/club-signup/${clubSignupId}/process-from-pay-stack`,
    payload,
    publicAxiosHeaderV2()
  );

export const updateClubSignupItems = (signupId, data) => {
  return axios.put(
    `${getV2RootUrl()}/club-signup/${signupId}/for-web`,
    { items: data },
    publicAxiosHeaderV2()
  );
};
